import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        errorStatusCodeEnum: {
			400: 'Erreur de validation',
            401: 'Vous n\'êtes pas authentifié',
            403: 'Vous n\'êtes pas autorisé',
            404: 'Non trouvé',
            500: 'Une erreur est survenue'
        },
        errorTypeEnum: {
            badRequest: 'Erreur de validation',
            forbidden: 'Vous n\'êtes pas autorisé',
            jsonValidationError: 'Erreur de validation',
            notValidDemand: 'Votre demande est invalide',
            demandNotFound: 'Votre demande est invalide',
            invalidCredentials: 'Les identifiants saisis ne sont pas valides',
            impossibleToDissociatePatrimonyFromAgencyThatDoesntExist: 'Un patrimoine doit avoir au moins une agence',
            impossibleToAssociatePatrimonyInAgencyForAlreadyAssociatedAgency: 'Cette agence est déjà associée au patrimoine',
            impossibleToDissociateUserIfRemainsOnlyOneAgency: 'Un user doit avoir au moins une agence',
            impossibleToRemoveOnlyAddressFromLot: 'Un lot doit avoir au moins une adresse',
            userAlreadyExist: 'Cet email est déjà utilisé',
            userAlreadyActived: 'Cet utilisateur est actif',
            userNotFound: 'Cet utilisateur n\'existe pas ou est inactif',
            loginAlreadyUsed: 'Cet email est déjà utilisé',
            impossibleToPerformCommandOnDisabledUser: 'Cet utilisateur est déjà désactivé',
            impossibleToUpdateLoginOfActiveUser: 'Cet utilisateur est actif',
            impossibleToReportFormalNoticeIfNoInterventionDeadlineWasDefined: 'Une date butoir doit avoir été définie',
            impossibleToReportFormalNoticeIfInterventionDeadlineIsNotExcedeed: 'La date butoir n\'est pas dépassée',
            impossibleToReportFormalNoticeIfNewDeadlineIsMinusThanPreviousInterventionDeadline: 'La date doit être posterieur à l\'actuelle mise en demeure',
            impossibleToDissociateUserIfRemainsOnlyOnePatrimony: 'Un gestionnaire doit avoir au moins un patrimoine',
            impossibleToUpgradeCompanyToStandardAccountIfNotIdentified: 'Un siret est nécessaire pour souscrire au compte standard',
            userAlreadyAssociatedWithThisPatrimony: 'Ce patrimoine est déjà associé au gestionnaire',
            lotReferenceAlreadyExist: 'Cette référence existe déjà pour ce patrimoine',
            lotNumberAlreadyExist: 'Ce numéro de lot existe déjà pour ce patrimoine',
            patrimonyNotFound: 'Patrimoine non trouvé',
            buildingDontExist: 'Bâtiment non trouvé',
            addressNotConform: 'Adresse invalide',
            impossibleToLinkAlreadyLinkedEntityWithPatrimonyContact: 'Ce contact est déjà associé',
            impossibleToAddContactThatAlreadyExistInThisPatrimonyContact: 'Ce moyen de contact existe déjà',
            impossibleToRemoveBecauseShouldHaveAtLeastOneRemainingContact: 'Au moins un moyen de contact doit être renseigné',
            siretAlreadyExist: 'Cette entreprise est déjà référencée',
            titleShouldBeUniq: 'Ce titre est déjà utilisé'
        },
        systemError: 'Erreur système',
        systemErrorText: [
            'L\'application rencontre des difficultés techniques.',
            'Veuillez réessayer ou contacter le support si le problème persiste.'
        ]
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/app/i18n.js